/** The browser-side file name for a stored submission report. */
export function submissionPdfFileName(submissionId: string): string {
  return `ConText-Submission-${submissionId}.pdf`;
}

/** Triggers a browser download of a Blob under the given file name. */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
